import { render } from "./Loading.vue?vue&type=template&id=22799b68&ts=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../build_modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__